import { defaultHttpClient } from '../../httpClient';

export interface BatchRedeemCouponsRequest {
  coupon_snos: number[];
}

export interface BatchRedeemCouponsResponse {
  redeemed_coupons: number[];
  coupons_count: number;
}

export const postBatchRedeemCoupons = (body: BatchRedeemCouponsRequest) => {
  return defaultHttpClient
    .request<BatchRedeemCouponsResponse>({
      method: 'POST',
      url: '/api/v2/coupons/batch_redeem/',
      data: body,
    })
    .then(result => result.data);
};
